<script lang="ts" setup>
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";
import BaseLayout from "./BaseLayout.vue";
import { useSidebarStore } from "@/stores";

const page = usePage();

const sidebarStore = useSidebarStore();
const hasBreadcrumb = computed(() => {
  return page.props.breadcrumbs && (page.props.breadcrumbs as any[]).length;
});
</script>

<template>
  <BaseLayout>
    <v-toolbar></v-toolbar>
    <div class="pb-8">
      <slot></slot>
    </div>
  </BaseLayout>
</template>
